(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-fit-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var WIDE = window.matchMedia('(min-width: 990px)');
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
    function list(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    /* the guide film. No bytes before the tap; the tap sets the source and plays it with sound and the browser's own
       controls (scrubbing, full screen) from the start second, the poster frame under it while it buffers. Only
       [start, end) plays: at the end second, or on a seek past it, it stops (leaving full screen) and the poster comes
       back reading "Watch again"; the next tap starts over. The sound fades over the last second where the browser lets
       a page set the volume (not iOS). It pauses once it has left the screen entirely, but never in full screen or
       picture-in-picture. */
    function film(fig) {
      if (!fig || fig.__fsv) return;
      var v = fig.querySelector('video'), b = fig.querySelector('[data-fs-watch]'), pos = fig.querySelector('.wl-fsteps__poster');
      if (!v || !b) return;
      fig.__fsv = true;
      var S = +fig.getAttribute('data-fs-start') || 0, E = +fig.getAttribute('data-fs-end') || 0, R = +fig.getAttribute('data-fs-rate') || 1;
      var on = false, raf = 0, base = 1, faded = false;
      function vol(x) { try { v.volume = Math.max(0, Math.min(1, x)); } catch (e) {} }
      function big() {
        var f = document.fullscreenElement || document.webkitFullscreenElement;
        return !!(f && (f === v || f.contains(v))) || !!v.webkitDisplayingFullscreen || document.pictureInPictureElement === v;
      }
      function leave() {
        try {
          if (document.fullscreenElement && document.exitFullscreen) { var p = document.exitFullscreen(); if (p && p.catch) p.catch(function () {}); }
          else if (document.webkitFullscreenElement && document.webkitExitFullscreen) document.webkitExitFullscreen();
          if (v.webkitDisplayingFullscreen && v.webkitExitFullscreen) v.webkitExitFullscreen();
          if (document.pictureInPictureElement === v && document.exitPictureInPicture) document.exitPictureInPicture().catch(function () {});
        } catch (e) {}
      }
      function rest() {
        if (!on) return;
        on = false;
        if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
        v.pause();
        leave();
        var had = document.activeElement === v, l = b.querySelector('[data-fs-label]');
        v.controls = false;
        v.hidden = true;
        if (pos) pos.hidden = false;
        b.hidden = false;
        if (l && b.getAttribute('data-again')) l.textContent = b.getAttribute('data-again');
        if (had) b.focus({ preventScroll: true });
      }
      function check() {
        if (!on) return;
        var left = E - v.currentTime;
        if (left <= 0.03) { rest(); return; }
        if (left < 1) { if (!faded) { faded = true; base = v.volume; } vol(base * left); }
        else if (faded) { faded = false; vol(base); }
      }
      function loop() { raf = 0; check(); if (on && !v.paused) raf = window.requestAnimationFrame(loop); }
      function go() {
        var img = pos && pos.querySelector('img');
        if (img && img.currentSrc && !v.getAttribute('poster')) v.poster = img.currentSrc;
        if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = v.getAttribute('data-fs-src') + (S > 0 ? '#t=' + S : ''); }
        else if (v.readyState > 0) v.currentTime = S;
        v.controls = true;
        v.muted = false;
        v.defaultPlaybackRate = R;
        v.playbackRate = R;
        faded = false;
        vol(1);
        on = true;
        v.hidden = false;
        b.hidden = true;
        if (pos) pos.hidden = true;
        v.focus({ preventScroll: true });
        var p = v.play();
        /* a browser that refuses sound without a fresh gesture: play muted, its own controls unmute it */
        if (p && p.catch) p.catch(function (e) { if (on && e && e.name === 'NotAllowedError' && !v.muted) { v.muted = true; var q = v.play(); if (q && q.catch) q.catch(function () {}); } });
      }
      b.addEventListener('click', go);
      v.addEventListener('play', function () { if (on && !raf) raf = window.requestAnimationFrame(loop); });
      v.addEventListener('timeupdate', check); /* a second guard: frames stop in a background tab */
      v.addEventListener('seeking', function () { if (!on) return; if (v.currentTime >= E - 0.03) rest(); else if (S > 0 && v.currentTime < S - 0.05) v.currentTime = S; else check(); });
      v.addEventListener('loadedmetadata', function () { if (S > 0 && v.currentTime < S - 0.05) v.currentTime = S; });
      v.addEventListener('ended', rest);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { if (!es[0].isIntersecting && on && !v.paused && !big()) v.pause(); }).observe(fig);
      }
    }

    /* desktop stage + reading light. The step whose top has passed the reading line (42% down the screen, 400px at
       most) is the current one: the steps up to it are lit, its number turns blue, and the stage cross-fades to its
       photo. The stage opens on step 01's photo (marked on in the markup, so it shows before this runs). Without script,
       or with reduced motion, there is no stage: every step shows its own photo and nothing moves. */
    function init(root) {
      if (!root || root.__fs) return;
      var steps = list(root, '[data-fs-step]');
      if (!steps.length) return;
      root.__fs = true;
      var layers = list(root, '[data-fs-layer]');
      var cur = -1, queued = false, live = false;
      function layerFor(n) {
        var want = n > 0 ? n : 1;
        return layers.filter(function (l) { return +l.getAttribute('data-fs-layer') === want; })[0];
      }
      function pick() {
        queued = false;
        if (!root.isConnected) { stop(); return; }
        var vh = window.innerHeight, line = Math.min(vh * 0.42, 400), n = 0;
        steps.forEach(function (st, i) { if (st.getBoundingClientRect().top <= line) n = i + 1; });
        /* the stage is about to scroll away with the section's end: show the last step before it goes */
        if (root.classList.contains('wl-fsteps--staged') && root.getBoundingClientRect().bottom <= vh + 2) n = steps.length;
        if (n === cur) return;
        cur = n;
        steps.forEach(function (st, i) { st.classList.toggle('is-lit', i < n); st.classList.toggle('is-on', i === n - 1); });
        if (!root.classList.contains('wl-fsteps--staged')) return;
        var on = layerFor(n);
        layers.forEach(function (l) { l.classList.toggle('is-on', l === on); });
      }
      function ask() { if (!queued) { queued = true; window.requestAnimationFrame(pick); } }
      function start() { if (live) return; live = true; window.addEventListener('scroll', ask, { passive: true }); window.addEventListener('resize', ask); ask(); }
      function stop() { if (!live) return; live = false; window.removeEventListener('scroll', ask); window.removeEventListener('resize', ask); }
      function mode() {
        var still = RM.matches;
        root.classList.toggle('wl-fsteps--lit', !still);
        root.classList.toggle('wl-fsteps--staged', !still && WIDE.matches);
        if (still) {
          var first = layerFor(0);
          steps.forEach(function (st) { st.classList.remove('is-lit', 'is-on'); });
          layers.forEach(function (l) { l.classList.toggle('is-on', l === first); });
          stop();
          return;
        }
        cur = -1;
        if ('IntersectionObserver' in window) ask(); else start();
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { if (es[0].isIntersecting && !RM.matches) start(); else { stop(); if (!RM.matches) ask(); } }, { rootMargin: '200px 0px' }).observe(root);
      }
      [WIDE, RM].forEach(function (q) { if (q.addEventListener) q.addEventListener('change', mode); else if (q.addListener) q.addListener(mode); });
      mode();
    }
    function boot(root) { film(root.querySelector('[data-fs-player]')); init(root); }
    function all() { list(document, '[data-fsteps]').forEach(boot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-fsteps]'); if (r) boot(r); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-help-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var offs = [];
    function setup() {
      offs.forEach(function (f) { f(); }); offs = [];
      Array.prototype.forEach.call(document.querySelectorAll('[data-help-nav]'), function (nav) {
        var links = Array.prototype.slice.call(nav.querySelectorAll('a[data-help-topic]'));
        var groups = [];
        links.forEach(function (a) {
          var el = null;
          try { el = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (e) {}
          if (el) groups.push({ a: a, el: el });
        });
        if (!groups.length) return;
        var cur = null, queued = false;
        function mark(g) {
          if (cur === g) return;
          cur = g;
          groups.forEach(function (x) {
            if (x === g) x.a.setAttribute('aria-current', 'true');
            else x.a.removeAttribute('aria-current');
          });
        }
        function pick() {
          queued = false;
          var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr-h')) * 10 || 64;
          var line = hdr + 48;
          var found = null;
          for (var i = 0; i < groups.length; i++) {
            if (groups[i].el.getBoundingClientRect().top <= line + 2) found = groups[i];
          }
          if (!found && groups[0].el.getBoundingClientRect().top < window.innerHeight * 0.7) found = groups[0];
          var last = groups[groups.length - 1].el;
          if (found && last.getBoundingClientRect().bottom < hdr) found = null; /* this hub is above you: nothing in it lights */
          mark(found);
        }
        function onScroll() {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(pick);
        }
        /* perf (2026-10-22): the scroll listener runs only while this hub (its nav or one of its groups) is on screen or
           within 200px of it, the way the care stickies do; once it is away, one last pick sets the state it is left in */
        var live = false, io = null;
        function on() { if (live) return; live = true; window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
        function off() { if (!live) return; live = false; window.removeEventListener('scroll', onScroll); onScroll(); }
        if ('IntersectionObserver' in window) {
          var seen = new Set();
          io = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
            if (seen.size) on(); else off();
          }, { rootMargin: '200px 0px' });
          io.observe(nav);
          groups.forEach(function (g) { io.observe(g.el); });
        } else on();
        window.addEventListener('resize', onScroll);
        window.addEventListener('hashchange', onScroll);
        window.addEventListener('load', onScroll);
        offs.push(function () {
          if (io) io.disconnect();
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          window.removeEventListener('hashchange', onScroll);
          window.removeEventListener('load', onScroll);
        });
        pick();
      });
    }
    /* phones: a group shows its first three questions; the button (or a link to a later question) shows the rest */
    function reveal() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-help]'), function (sec) { sec.setAttribute('data-help-js', ''); });
      if (!location.hash || location.hash.length < 2) return;
      var el = null;
      try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
      var g = el && el.closest ? el.closest('.wl-help__group') : null;
      if (g) g.classList.add('is-all');
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-more-btn]') : null;
      if (!b) return;
      var g = b.closest('.wl-help__group');
      if (g) g.classList.add('is-all');
    });
    window.addEventListener('hashchange', reveal);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
    else reveal();
    document.addEventListener('shopify:section:load', reveal);
    var was = [];
    window.addEventListener('beforeprint', function () {
      was = [];
      Array.prototype.forEach.call(document.querySelectorAll('.wl-help .wl-qa details'), function (d) { was.push([d, d.open]); d.open = true; });
    });
    window.addEventListener('afterprint', function () { was.forEach(function (p) { p[0].open = p[1]; }); was = []; });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-howto-care"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function rows(root) { return root ? Array.prototype.slice.call(root.querySelectorAll('.wl-howto-care__d')) : []; }
    /* a hash that names a group opens every row in it (a hash that names a row is opened by wl.js) */
    function openHash() {
      var id = location.hash.slice(1), el = null;
      if (!id) return;
      try { el = document.getElementById(decodeURIComponent(id)); } catch (e) {}
      if (!el) return;
      if (el.classList && el.classList.contains('wl-howto-care__group')) rows(el).forEach(function (d) { d.open = true; });
      else if (el.tagName === 'DETAILS' && el.classList.contains('wl-howto-care__d')) el.open = true;
      else { var d = el.closest && el.closest('.wl-howto-care__d'); if (d) d.open = true; }
    }
    /* the printed page opens every row, then puts them back */
    var was = [];
    window.addEventListener('beforeprint', function () {
      was = [];
      Array.prototype.forEach.call(document.querySelectorAll('.wl-howto-care__d'), function (d) { was.push([d, d.open]); d.open = true; });
    });
    window.addEventListener('afterprint', function () { was.forEach(function (p) { p[0].open = p[1]; }); was = []; });
    /* sticky photo: the picture of the group that has reached the middle of the screen fades in */
    function sticky() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-hsticky]'), function (root) {
        if (root.__hs) return;
        var groups = Array.prototype.slice.call(root.querySelectorAll('[data-hs-group]'));
        var pics = Array.prototype.slice.call(root.querySelectorAll('.wl-hsticky__pic'));
        if (!groups.length || !pics.length) return;
        root.__hs = true;
        var cur = -1, queued = false, live = false;
        function pick() {
          queued = false;
          var line = window.innerHeight * 0.5, i = 0;
          groups.forEach(function (g, k) { if (g.getBoundingClientRect().top <= line) i = k; });
          if (i === cur) return;
          cur = i;
          pics.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        }
        function ask() { if (!queued) { queued = true; window.requestAnimationFrame(pick); } }
        function on() { if (live) return; live = true; window.addEventListener('scroll', ask, { passive: true }); window.addEventListener('resize', ask); ask(); }
        function off() { if (!live) return; live = false; window.removeEventListener('scroll', ask); window.removeEventListener('resize', ask); }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { if (es[0].isIntersecting) on(); else { off(); ask(); } }, { rootMargin: '200px 0px' }).observe(root);
        } else on();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky);
    else sticky();
    document.addEventListener('shopify:section:load', sticky);
    window.addEventListener('hashchange', openHash);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openHash);
    else openHash();
    document.addEventListener('shopify:section:load', openHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-main-product"]) return;
  try {
    
  /* The 3D panel (gallery panel 1): the owner's Spline carrier turning slowly on its own.
     - The poster (the packshot) is the LCP. The viewer loads after the load event, when the browser is idle, and only
       while the panel is on screen; it is never fetched under reduced motion or Save-Data (the poster stays).
     - The turn: app.findObjectByName(object).rotation.y, advanced by requestAnimationFrame (one turn per data-turn
       seconds), only while the panel is visible, the tab is shown and Pause isn't pressed.
     - Zoom: data-zoom × min(1, width / height) of the viewer (Spline's setZoom is relative, so only the change applies).
       Measured with the real scene: the model's pivot is off-centre, so it swings as it turns; at 1.3 it is cut by the
       panel's edges at six of eight angles, at 1.0 no angle touches the edge (the widest, the back, fills ~92%).
     - The canvas takes no pointer events: swipes scroll the photos and the page. The orbit controls are switched off.
     - Colour: the model is recoloured in the browser (wl-3d-tint.js) to the picked colour's line in Theme settings >
       WaterLand > 3D model colours. If recolouring isn't possible, only the colour the scene is made in (data-own)
       shows the model; every other colour keeps its packshot, so the model never shows in the wrong colour.
     - A colour change swaps the panel (Dawn; the panel's media id carries the colour). The model that is already
       loaded moves into the new panel and morphs to the new colour (no reload); its turn, zoom and Pause carry over.
       State for checks: li[data-g3d] = poster | wait | loading | turning | still.
     - perf (pack 2, 2026-10-22): Spline's own render loop runs only while the panel can be seen: at least a quarter of
       it on screen, the tab shown, nothing over the page (the bag, the menu, a dialog) and "Made for the water." not
       holding the page's one live model (the viewer's wlHeld). Otherwise app.stop() ends the loop, so Spline neither
       draws nor replays its 32 smoothing frames off screen, and its scroll listener is off. Pause only stops the turn.
       The scene file is fetched once for the page (window.wlScene, shared with wl-product-scenes). */
  (function () {
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var calm = function () { return RM.matches || !!(navigator.connection && navigator.connection.saveData); };
    var loaded = document.readyState === 'complete', queue = [];
    window.addEventListener('load', function () { loaded = true; queue.splice(0).forEach(function (f) { f(); }); });
    var idle = function (f) { if (window.requestIdleCallback) window.requestIdleCallback(f, { timeout: 2500 }); else setTimeout(f, 300); };
    var afterLoad = function (f) { if (loaded) idle(f); else queue.push(function () { idle(f); }); };
    /* the one loaded model: { v, app, obj, base, angle, zoom, paused, li, ready, noScroll } */
    var live = null;
    /* perf (pack 2, 2026-10-22): one download of the 3D scene for the page. The gallery's 3D panel and "Made for the
       water." show the same scene file: it is fetched once (the browser's usual cache rules apply) and each viewer gets
       it from memory, as a blob: address. If that fails, a viewer gets the file's own address, as before. The same
       code is in wl-product-scenes; whichever runs first sets it up. */
    var scene = window.wlScene || (window.wlScene = (function () {
      var memo = {};
      return function (url) {
        if (!memo[url]) {
          memo[url] = window.fetch && window.URL && URL.createObjectURL
            ? fetch(url).then(function (r) { if (!r.ok) throw new Error('scene ' + r.status); return r.blob(); }).then(function (b) { return URL.createObjectURL(b); }).catch(function () { return url; })
            : Promise.resolve(url);
        }
        return memo[url];
      };
    })());
    /* perf (pack 2): something over the page: the bag, the menu or a dialog (the buy bar's own test, below), or any
       drawer that locks the page (Dawn adds overflow-hidden* to the body) */
    var covered = function () {
      return /(^|\s)overflow-hidden(-[a-z]+)?(\s|$)/.test(document.body.className) || !!(document.querySelector('dialog[open]:not(.wl-is-out)') || document.querySelector('cart-drawer.active') || document.querySelector('.menu-drawer-container.menu-opening'));
    };
    /* kept up to date by the observers below, so the turn's every frame reads a flag, not three queries */
    var wakers = [], wasCovered = false, watching = false;
    var isCovered = function () { return watching ? wasCovered : covered(); };
    var recheck = function () { var c = covered(); if (c === wasCovered) return; wasCovered = c; wakers.slice().forEach(function (f) { f(); }); };
    if (window.MutationObserver) {
      var watch = function () {
        watching = true; wasCovered = covered();
        new MutationObserver(recheck).observe(document.body, { attributes: true, attributeFilter: ['class'] });
        new MutationObserver(recheck).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
        [].forEach.call(document.querySelectorAll('cart-drawer, .menu-drawer-container'), function (el) { new MutationObserver(recheck).observe(el, { attributes: true, attributeFilter: ['class'] }); });
      };
      if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
    }
    var fit = function (st) {
      if (!st || !st.app || typeof st.app.setZoom !== 'function') return;
      var r = st.v.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var z = (+st.li.dataset.zoom || 1) * Math.min(1, r.width / r.height);
      if (Math.abs(z - st.zoom) < 0.001) return;
      st.app.setZoom(z / st.zoom);
      st.zoom = z;
    };

    function init(li) {
      if (li.wl3d) return;
      li.wl3d = true;
      var box = li.querySelector('[data-g3d-box]'), ctl = li.querySelector('[data-g3d-ctl]');
      if (!box) return;
      if (calm() || !li.dataset.js || !li.dataset.scene || !('IntersectionObserver' in window)) { li.dataset.g3d = 'poster'; return; }
      li.dataset.g3d = 'wait';
      var st = null, last = 0, raf = 0, vis = false, started = false, io = null;
      var period = Math.max(6, +li.dataset.turn || 24) * 1000;
      /* perf (pack 2): awake = the panel can be seen (see the top); the model turns only while awake and not paused */
      var awake = function () { return !!st && st.li === li && vis && !document.hidden && li.isConnected && !st.v.wlHeld && !isCovered(); };
      var running = function () { return !!st && !!st.obj && !st.paused && awake(); };
      /* Spline's loop on or off. Never stop() in the first moment after load-complete: Spline starts its loop just after
         it, and a stop() before that leaves the loop running while marked as stopped (st.ready waits for it) */
      var glLoop = function () {
        var app = st && st.app;
        if (!app || st.li !== li || !st.ready || app.disposed || typeof app.stop !== 'function') return;
        try {
          if (awake()) {
            if (app.isStopped) {
              app.play();
              /* play() turns the orbit controls back on: off again (the canvas takes no pointer events anyway) */
              var ct = app.controls; if (ct) { ct.enabled = false; if (ct.orbitControls) ct.orbitControls.enabled = false; }
            }
            if (st.noScroll && typeof app._onScroll === 'function') { st.noScroll = false; document.addEventListener('scroll', app._onScroll); app._onScroll(); }
          } else {
            if (!app.isStopped) app.stop();
            if (!st.noScroll && typeof app._onScroll === 'function') { st.noScroll = true; document.removeEventListener('scroll', app._onScroll); }
          }
        } catch (e) {}
      };
      var frame = function (now) {
        raf = 0;
        if (!running()) return;
        if (last) st.angle = (st.angle + (now - last) / period * Math.PI * 2) % (Math.PI * 2);
        last = now;
        st.obj.rotation.y = st.base + st.angle;
        if (typeof st.app.requestRender === 'function') st.app.requestRender();
        li.wlAngle = st.angle; /* perf (2026-10-22): a JS property for checks, not an attribute written on every frame */
        raf = requestAnimationFrame(frame);
      };
      var tick = function () {
        if (!li.isConnected) {
          if (raf) cancelAnimationFrame(raf); raf = 0; if (io) io.disconnect(); document.removeEventListener('visibilitychange', tick); var k = wakers.indexOf(tick); if (k > -1) wakers.splice(k, 1);
          glLoop(); /* perf (pack 2): a panel swapped out (colour change) stops its model until the new panel takes it */
          return;
        }
        glLoop();
        if (running()) { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
        else if (raf) { cancelAnimationFrame(raf); raf = 0; }
      };
      var mark = function () {
        if (!ctl || !st) return;
        ctl.setAttribute('aria-pressed', st.paused ? 'true' : 'false');
        ctl.setAttribute('aria-label', st.paused ? (ctl.dataset.play || 'Play') : (ctl.dataset.pause || 'Pause'));
        var u = ctl.querySelector('use'); if (u) u.setAttribute('href', st.paused ? '#i-play' : '#i-pause');
        li.dataset.g3dPaused = st.paused ? '1' : '0';
      };
      /* colour the model for this panel, then show it (now: no cross-fade, the model is already on screen) */
      var show = function (ms, now) {
        var ok = !!li.dataset.tint && !!window.wlTint && window.wlTint(st.app, li.dataset.tint, ms);
        if (!ok && li.dataset.own !== 'true') { li.dataset.g3d = 'poster'; li.classList.remove('wl-is-3d'); if (ctl) ctl.hidden = true; return; }
        li.dataset.g3d = st.obj ? 'turning' : 'still';
        if (now) li.classList.add('wl-g3d-now', 'wl-is-3d');
        else requestAnimationFrame(function () { li.classList.add('wl-is-3d'); });
        if (ctl && st.obj) { ctl.hidden = false; mark(); }
        st.v.wlWake = tick; /* for wl-product-scenes: re-check after it holds or releases this viewer */
        tick();
      };
      var load = function () {
        if (started || !vis || !li.isConnected) return;
        started = true;
        if (live && live.li !== li && !live.li.isConnected && !live.app.disposed) {
          st = live; st.li = li;
          box.appendChild(st.v);
          try { fit(st); } catch (e) {}
          if (st.obj) st.obj.rotation.y = st.base + st.angle;
          show(450, true);
          return;
        }
        /* WebGL off: the viewer would throw "Error creating WebGL context", so the packshot simply stays */
        var gl = window.wlHasGL ? window.wlHasGL() : (function () { try { var c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (e) { return false; } })();
        if (!gl) { li.dataset.g3d = 'poster'; li.classList.remove('wl-is-3d'); if (ctl) ctl.hidden = true; return; }
        li.dataset.g3d = 'loading';
        if (!customElements.get('spline-viewer') && !document.querySelector('script[data-wl-spline]')) {
          var sc = document.createElement('script');
          sc.type = 'module'; sc.src = li.dataset.js; sc.setAttribute('data-wl-spline', '');
          document.head.appendChild(sc);
        }
        var v = document.createElement('spline-viewer');
        v.hint = false; /* a Boolean property: the attribute hint="" would switch the drag hint on */
        v.setAttribute('aria-hidden', 'true');
        v.setAttribute('loading-anim-type', 'none');
        v.wlWake = tick; /* set before the scene arrives, so wl-product-scenes holds this viewer instead of stopping it */
        scene(li.dataset.scene).then(function (u) { if (v.isConnected || li.isConnected) v.setAttribute('url', u); });
        v.addEventListener('load-complete', function () {
          var app = v._spline, obj = null;
          try { obj = app && app.findObjectByName(li.dataset.object || 'Group'); } catch (e) { obj = null; }
          if (obj && !obj.rotation) obj = null;
          try { if (app && app.controls) app.controls.enabled = false; } catch (e) {}
          if (!app || !li.isConnected) return;
          st = live = v.wlSt = { v: v, app: app, obj: obj, base: obj ? obj.rotation.y : 0, angle: 0, zoom: 1, paused: false, li: li, ready: false, noScroll: false };
          try { fit(st); } catch (e) {}
          show(0, false);
          var me = st; setTimeout(function () { me.ready = true; if (me.li.isConnected && me.v.wlWake) me.v.wlWake(); }, 120);
        }, { once: true });
        if (window.ResizeObserver) new ResizeObserver(function () { try { fit(v.wlSt); } catch (e) {} }).observe(v);
        box.appendChild(v);
      };
      io = new IntersectionObserver(function (es) {
        vis = es[es.length - 1].isIntersecting;
        if (vis && !started) { if (live && !live.li.isConnected) load(); else afterLoad(load); }
        tick();
      }, { threshold: 0.25 });
      io.observe(li);
      document.addEventListener('visibilitychange', tick);
      wakers.push(tick);
      if (ctl) ctl.addEventListener('click', function () {
        if (!st) return;
        st.paused = !st.paused;
        mark();
        tick();
      });
    }

    /* the thumbnails (a row under the panel on phones, a strip beside it on desktop): one button per slide (from
       data-thumb), the current one marked and kept in view; rebuilt whenever Dawn swaps the slides for another colour */
    function thumbs(g) {
      if (g.wlThumbs) return;
      var track = g.querySelector('.wl-gallery__track'), list = g.querySelector('[data-wl-thumbs]');
      if (!track || !list) return;
      g.wlThumbs = true;
      var items = [], cur = -1;
      /* scroll the row (or the strip) itself, never the page, so the current thumb shows with a neighbour on each side:
         the next one is always a tap away */
      var reveal = function (b, glide) {
        var row = list.scrollWidth > list.clientWidth + 1, col = list.scrollHeight > list.clientHeight + 1;
        if (!row && !col) return;
        var lr = list.getBoundingClientRect(), br = b.getBoundingClientRect(), dx = 0, dy = 0;
        if (row) {
          var px = Math.min(br.width * 1.5, lr.width / 3);
          if (br.left < lr.left + px) dx = br.left - lr.left - px; else if (br.right > lr.right - px) dx = br.right - lr.right + px;
        }
        if (col) {
          var py = Math.min(br.height * 1.5, lr.height / 3);
          if (br.top < lr.top + py) dy = br.top - lr.top - py; else if (br.bottom > lr.bottom - py) dy = br.bottom - lr.bottom + py;
        }
        if (dx || dy) list.scrollBy({ left: dx, top: dy, behavior: glide && !RM.matches ? 'smooth' : 'auto' });
      };
      var mark = function () {
        var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w), bs = list.querySelectorAll('button');
        [].forEach.call(bs, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        if (bs[i] && i !== cur && !list.hidden) reveal(bs[i], cur >= 0);
        cur = i;
      };
      var build = function () {
        var bgli = track.querySelector('li[data-bg]');
        if (bgli && bgli.dataset.bg) g.style.setProperty('--wl-gal-bg', bgli.dataset.bg);
        items = [].slice.call(track.children).filter(function (li) { return li.matches('li[data-media-id]') && !li.hidden; });
        list.textContent = '';
        var tpl = list.dataset.label || 'Show photo [n] of [total]';
        items.forEach(function (li, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'wl-thumbs__b' + (li.hasAttribute('data-wl-3d') ? ' wl-thumbs__b--3d' : '') + (li.classList.contains('wl-gallery__slide--pack') ? ' wl-thumbs__b--pack' : '') + (li.classList.contains('wl-gallery__slide--clip') ? ' wl-thumbs__b--clip' : '');
          b.setAttribute('aria-label', li.dataset.thumbLabel || tpl.replace('[n]', i + 1).replace('[total]', items.length));
          if (li.dataset.thumb) { var im = document.createElement('img'); im.src = li.dataset.thumb; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; b.appendChild(im); }
          b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: RM.matches ? 'auto' : 'smooth' }); });
          var it = document.createElement('li'); it.appendChild(b); list.appendChild(it);
        });
        list.hidden = items.length < 2;
        cur = -1;
        mark();
      };
      var t = 0;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      /* a colour change swaps the slides: rebuild the thumbs, set up a new 3D panel, and let wl.js set up a new clip
         (its living video runs on shopify:section:load for the given root) */
      new MutationObserver(function () {
        build(); scan(g);
        if (track.querySelector('[data-live-scope]:not([data-live])')) g.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { wl: 'gallery' } }));
      }).observe(track, { childList: true });
      build();
    }

    function scan(root) {
      [].forEach.call((root || document).querySelectorAll('[data-wl-3d]'), init);
      [].forEach.call((root || document).querySelectorAll('.wl-pdp-info [data-gallery]'), thumbs);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  /* The phone buy bar. It comes up only once the in-page Add to bag (or, for a sold-out colour, the Notify form) has
     scrolled up out of view, its bottom above the header's bottom, and goes again as soon as the visitor scrolls back up
     to it: so it never shows on the first screen, never covers the name, the line or the price, and never doubles the
     button in view. It also stays away from the FAQ (#faq or any [data-wl-bar-end]) and the footer on, and while the bag,
     the menu drawer or a sheet is open (one fixed bottom element at a time). Measured on every scroll frame, so it is
     right however the page got there (a reload that keeps the scroll, an anchor, a colour change). */
  (function () {
    function setup() {
      var bar = document.querySelector('[data-wl-buybar]');
      if (!bar || bar.wlBar) return;
      bar.wlBar = true;
      /* looked up each time: Dawn may swap parts of the buy box on a colour change */
      var main = function () { return document.querySelector('.wl-pdp-info [data-atc-main]'); };
      var headerBottom = function () { var h = document.querySelector('.wl-header'); return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0; };
      /* the in-page action that is shown: Add to bag, or the Notify form (the other is hidden) */
      var watched = function (m) {
        var on = [].filter.call(m.querySelectorAll('[data-wl-bar-watch]'), function (el) { return el.getClientRects().length > 0; });
        return on.length ? on : [m];
      };
      var past = function () {
        var m = main();
        if (!m || !m.getClientRects().length) return false;
        var top = headerBottom();
        return watched(m).every(function (el) { return el.getBoundingClientRect().bottom <= top; });
      };
      /* perf (2026-10-22): the FAQ and the footer are looked up once (again only if the theme editor replaced one) */
      var ends = null;
      var atEnd = function () {
        var lim = window.innerHeight + 160;
        if (!ends || ends.some(function (el) { return !el.isConnected; })) ends = [].slice.call(document.querySelectorAll('[data-wl-bar-end], #faq, .wl-footer'));
        return ends.some(function (el) { var r = el.getBoundingClientRect(); return r.height > 0 && r.top < lim; });
      };
      var blocked = function () {
        return !!(document.querySelector('dialog[open]:not(.wl-is-out)') || document.querySelector('cart-drawer.active') || document.querySelector('.menu-drawer-container.menu-opening'));
      };
      var upd = function () {
        if (!bar.isConnected) return;
        var on = past() && !atEnd() && !blocked();
        bar.classList.toggle('wl-is-on', on);
        if (bar.inert !== !on) bar.inert = !on;
      };
      bar.upd = upd; /* wl.js's sync() calls it when a dialog, the bag or the menu opens or closes */
      var raf = 0;
      var ask = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; upd(); }); };
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', ask);
      window.addEventListener('load', ask);
      document.addEventListener('close', function (e) { if (e.target && e.target.tagName === 'DIALOG') ask(); }, true);
      upd();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
    document.addEventListener('shopify:section:load', setup);
  })();

  /* An in-page link to #check (a Common questions answer, say) opens Find your fit: it presses one of the page's own
     "Find your fit" buttons, so wl.js's open, focus and close stay the single path. */
  (function () {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.hash !== '#check' || a.pathname !== location.pathname || a.hasAttribute('data-open')) return;
      var go = document.querySelector('.wl-pdp-info button[data-open="check"]:not([hidden])');
      if (!go || !document.getElementById('check')) return;
      e.preventDefault();
      go.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-page-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var off = null;
    function setup() {
      if (off) { off(); off = null; }
      var slot = document.querySelector('[data-jump]');
      if (!slot) return;
      var bar = slot.querySelector('[data-jumpbar]');
      var list = bar.querySelector('.wl-jumpbar__list');
      var main = slot.closest('main') || document.getElementById('MainContent');
      var items = [];
      Array.prototype.forEach.call(bar.querySelectorAll('a[href^="#"]'), function (a) {
        var el = null;
        try { el = document.getElementById(decodeURIComponent(a.hash.slice(1))); } catch (e) {}
        a.parentNode.hidden = !el;
        if (el) items.push({ a: a, el: el });
      });
      if (items.length < 2) { slot.hidden = true; return; }
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = null, queued = false;
      function hdr() { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr-h')) * 10 || 64; }
      /* perf (2026-10-22): the header's height, the cover and the desktop query are read once (the header's height
         again on resize), not on every scroll frame */
      var hdrH = hdr();
      var inCover = !!slot.closest('.wl-cover, .wl-phero--half');
      var deskQ = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
      function mark(it) {
        if (it === cur) return;
        cur = it;
        items.forEach(function (x) { if (x === it) x.a.setAttribute('aria-current', 'true'); else x.a.removeAttribute('aria-current'); });
        if (list.scrollWidth > list.clientWidth + 4) {
          list.scrollTo({ left: it ? it.a.parentNode.offsetLeft - (list.clientWidth - it.a.offsetWidth) / 2 : 0, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function pick() {
        queued = false;
        /* perf (2026-10-22): every read first, then the writes, so a frame lays the page out once (it used to read and
           write in turns, up to three forced layouts a frame). The slot keeps the bar's height, so docking moves nothing
           and the reads stay true after the writes. */
        var h = hdrH, was = bar.classList.contains('is-stuck'), bh = bar.offsetHeight;
        var desk = !!(deskQ && deskQ.matches);
        var st = slot.getBoundingClientRect().top, mb = main ? main.getBoundingClientRect().bottom : 0, vh = window.innerHeight;
        var tops = items.map(function (x) { return x.el.getBoundingClientRect().top; });
        /* inside a cover, desktop keeps the chips where they are (frosted, centred); phones dock them as one row, unless the page asks for no dock */
        var stuck = !slot.hasAttribute('data-nodock') && !(inCover && desk) && st < h;
        var gone = stuck && main && mb < vh * 0.6;
        if (!was) { var jh = bh + 'px'; if (slot.style.getPropertyValue('--jump-h') !== jh) slot.style.setProperty('--jump-h', jh); }
        if (was !== stuck) { bar.classList.toggle('is-stuck', stuck); bh = bar.offsetHeight; } /* only in the frame it docks or undocks */
        bar.classList.toggle('is-gone', !!gone);
        if (bar.inert !== !!gone) bar.inert = !!gone;
        var line = h + bh + 32;
        var found = null;
        if (stuck) { for (var i = 0; i < items.length; i++) { if (tops[i] <= line) found = items[i]; } }
        mark(found);
      }
      function ask() { if (!queued) { queued = true; window.requestAnimationFrame(pick); } }
      window.addEventListener('scroll', ask, { passive: true });
      function resized() { hdrH = hdr(); bar.classList.remove('is-stuck', 'is-gone'); ask(); }
      window.addEventListener('resize', resized);
      off = function () { window.removeEventListener('scroll', ask); window.removeEventListener('resize', resized); bar.classList.remove('is-stuck', 'is-gone'); };
      pick();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('shopify:section:load', setup);

    /* a link that arrives with #anchor lands true: once the fonts and pictures have settled the page, scroll to the
       anchor once more, unless the reader has already started scrolling (the first landing happens before they do) */
    (function () {
      if (!location.hash || location.hash.length < 2) return;
      var moved = false;
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (n) { window.addEventListener(n, function () { moved = true; }, { passive: true, once: true }); });
      function again() {
        if (moved) return;
        var el = null;
        try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) {}
        if (el) el.scrollIntoView();
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { window.requestAnimationFrame(again); });
      window.addEventListener('load', function () { window.setTimeout(again, 80); }, { once: true });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-product-scenes"] && !Shopify.designMode) return;
  try {
    
  /* "Made for the water.": the pinned 3D scroll scene (see the comment at the top of the section).
     State for checks: [data-made] gets data-made-state = still | poster | loading | 3d | packshot, data-made-beat
     (0–4) and data-made-active (1 while on screen); root.wlP holds the progress (perf, 2026-10-22: it was the stage's
     --p, which nothing reads, and writing it restyled the whole stage on every frame).
     perf (pack 2, 2026-10-22): the scene file is fetched once for the page (window.wlScene, shared with the gallery's
     3D panel in wl-main-product); while this scene is on screen it holds the gallery's viewer (wlHeld) and on leaving
     lets it decide for itself (wlWake), so the gallery starts again only if it can be seen; the model is moved, and
     Spline's 32 smoothing frames restarted, only when its pose has changed. */
  (function () {
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var calm = function () { return RM.matches || !!(navigator.connection && navigator.connection.saveData); };
    var ss = function (a, b, t) { t = Math.min(1, Math.max(0, (t - a) / (b - a))); return t * t * (3 - 2 * t); };
    var lerp = function (a, b, k) { return a + (b - a) * k; };
    /* keyframes: [progress, turn (degrees), size, x, y, buckle]. size: the model's height as a share of the stage
       (phones: of the stage's width / 1.4, so it never overflows); x, y: where its centre (or the buckle) sits, as a
       share of the stage; buckle: 0 = frame the whole carrier, 1 = frame the buckle. Progress below 0 is the entry,
       before the stage pins, so the carrier is already rising as the statement arrives: its top third is up behind the
       statement on the first screen (rec-3's first frame), never words on an empty blue. */
    /* each beat holds its pose while its words are up (about 40% of a screen of scroll); the buckle close-up holds
       until "Buckles made for water." has gone, and only then pulls back, so the words never sit on the carrier */
    var KD = [[-0.5, -150, 0.5, 0.5, 0.62, 0], [-0.22, -110, 0.53, 0.5, 0.66, 0], [0, -70, 0.56, 0.5, 0.8, 0], [0.1, -24, 0.6, 0.5, 0.64, 0], [0.16, 0, 0.62, 0.5, 0.6, 0],
              [0.21, 0, 0.74, 0.62, 0.53, 0], [0.37, 10, 0.74, 0.62, 0.53, 0], [0.45, 180, 0.64, 0.48, 0.53, 0], [0.64, 190, 0.64, 0.48, 0.53, 0],
              [0.7, 45, 2.7, 0.64, 0.5, 1], [0.92, 36, 2.7, 0.64, 0.5, 1], [0.98, 0, 0.66, 0.5, 0.6, 0], [1, 0, 0.66, 0.5, 0.6, 0]];
    /* phones: the carrier steps aside (x 0.22) only when the optional clip card is on; the owner turned it off */
    var CX = 0.5;
    var KM = [[-0.5, -150, 0.8, 0.5, 1.0, 0], [-0.22, -110, 0.83, 0.5, 0.93, 0], [0, -70, 0.86, 0.5, 0.86, 0], [0.1, -24, 0.92, 0.5, 0.68, 0], [0.16, 0, 0.95, 0.5, 0.64, 0],
              [0.21, 0, 1.1, 0.5, 0.4, 0], [0.37, 10, 1.1, 0.5, 0.4, 0], [0.45, 180, 0.9, CX, 0.36, 0], [0.64, 190, 0.9, CX, 0.36, 0],
              [0.7, 45, 3.2, 0.5, 0.3, 1], [0.92, 36, 3.2, 0.5, 0.3, 1], [0.98, 0, 1.05, 0.5, 0.62, 0], [1, 0, 1.05, 0.5, 0.62, 0]];
    /* the words: [in from, in to, out from, out to] in progress. Each beat's words are whole for 0.16-0.17 of the pin
       (about 36-41% of a screen of scroll at 320svh); the buckle's words arrive once the close-up has landed */
    var WIN = [[-9, -9, 0.12, 0.16], [0.16, 0.2, 0.36, 0.4], [0.4, 0.44, 0.61, 0.64], [0.69, 0.73, 0.89, 0.92]];
    var CLIP = [0.4, 0.46, 0.6, 0.65];
    /* the packshot: the model's height is about 66% of the square; its buckle sits at 17% / 25% */
    var PACK_H = 0.66, PACK_BUCKLE = [0.17, 0.25];

    /* perf (pack 2, 2026-10-22): one download of the 3D scene for the page. The gallery's 3D panel and "Made for the
       water." show the same scene file: it is fetched once (the browser's usual cache rules apply) and each viewer gets
       it from memory, as a blob: address. If that fails, a viewer gets the file's own address, as before. The same
       code is in wl-main-product; whichever runs first sets it up. */
    var scene = window.wlScene || (window.wlScene = (function () {
      var memo = {};
      return function (url) {
        if (!memo[url]) {
          memo[url] = window.fetch && window.URL && URL.createObjectURL
            ? fetch(url).then(function (r) { if (!r.ok) throw new Error('scene ' + r.status); return r.blob(); }).then(function (b) { return URL.createObjectURL(b); }).catch(function () { return url; })
            : Promise.resolve(url);
        }
        return memo[url];
      };
    })());

    function poseAt(K, p) {
      if (p <= K[0][0]) return K[0].slice(1);
      for (var i = 1; i < K.length; i++) {
        if (p <= K[i][0]) {
          var a = K[i - 1], b = K[i], k = ss(a[0], b[0], p), o = [];
          for (var j = 1; j < a.length; j++) o.push(lerp(a[j], b[j], k));
          return o;
        }
      }
      return K[K.length - 1].slice(1);
    }

    function init(root) {
      if (root.wlMade) return;
      root.wlMade = true;
      var stage = root.querySelector('[data-made-stage]'), poster = root.querySelector('[data-made-poster]'), glBox = root.querySelector('[data-made-gl]');
      var beats = [].slice.call(root.querySelectorAll('[data-made-beat]')), clip = root.querySelector('[data-made-clip]');
      if (clip) { KM[7][3] = KM[8][3] = 0.22; }
      var back = poster && poster.querySelector('.wl-made__back'), front = poster && poster.querySelector('.wl-made__front');
      if (!stage || !poster) return;
      if (calm() || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) { root.dataset.madeState = 'still'; return; }
      var tints = {};
      try { tints = JSON.parse((root.querySelector('[data-made-tints]') || {}).textContent || '{}'); } catch (e) { tints = {}; }
      root.classList.add('wl-made--scroll');
      root.dataset.madeState = 'poster';
      var colour = root.dataset.color || '', own = root.dataset.own || '';
      var v = null, app = null, G = null, g = null, cam = null, base = null, active = false, stopped = [], raf = 0, pose = null, W = 0, H = 0;
      /* perf (2026-10-22): near: on screen or within a quarter screen (only then does the scene paint); posterUntil: the
         packshot keeps following the scene through its 600ms fade-out after the 3D takes over */
      var near = false, posterUntil = 0;
      /* perf (pack 2): placed: the pose last handed to Spline (moving the model restarts its 32 smoothing frames, so an
         unchanged pose is not handed again); noScroll: Spline's scroll listener is off while the scene is stopped */
      var placed = '', noScroll = false, glReady = false;
      /* rest: Spline's loop off (only once glReady: see load-complete below); wake: on again */
      var rest = function () {
        if (!app || !glReady || typeof app.stop !== 'function') return;
        try {
          if (!app.isStopped) app.stop();
          if (!noScroll && typeof app._onScroll === 'function') { noScroll = true; document.removeEventListener('scroll', app._onScroll); }
        } catch (e) {}
      };
      var wake = function () {
        if (!app || typeof app.play !== 'function') return;
        try {
          if (app.isStopped) {
            app.play();
            /* play() turns the orbit controls back on: off again (the canvas takes no pointer events anyway) */
            var ct = app.controls; if (ct) { ct.enabled = false; if (ct.orbitControls) ct.orbitControls.enabled = false; }
          }
          if (noScroll && typeof app._onScroll === 'function') { noScroll = false; document.addEventListener('scroll', app._onScroll); app._onScroll(); }
        } catch (e) {}
      };

      /* ---- the 3D model ---- */
      var V3 = null, local = { c: null, b: null, top: null, bot: null }, fitH = 0;
      var three = function () { var o = null; app._scene.traverse(function (x) { if (!o && x.name === (root.dataset.object || 'Group') && x.isObject3D) o = x; }); return o; };
      var colourOf = function (m) {
        var hsl = null;
        [].concat(m.material || []).forEach(function (mm) {
          ((mm && mm.layers) || []).forEach(function (l) {
            if (hsl || !l || l.type !== 'color' || !l.uniforms) return;
            var u = l.uniforms['f' + l.id + '_color'];
            if (u && u.value && u.value.isColor) { hsl = {}; (u.wlOrig || u.value).getHSL(hsl); }
          });
        });
        return hsl;
      };
      /* the carrier's centre and its top buckle, in the model's own space (measured once, front-on) */
      var measure = function () {
        G.updateMatrixWorld(true); cam.updateMatrixWorld(true);
        var mn = new V3(1e9, 1e9, 1e9), mx = new V3(-1e9, -1e9, -1e9), dark = [];
        var shown = function (o) { for (var x = o; x && x !== G; x = x.parent) if (x.visible === false) return false; return true; };
        G.traverse(function (o) {
          if (!o.isMesh || !o.geometry || !shown(o)) return;
          if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
          var bb = o.geometry.boundingBox, pa = o.geometry.attributes && o.geometry.attributes.position;
          /* the real extent from the vertices (a transformed bounding box overshoots), sampled on big meshes */
          if (pa && pa.count) {
            for (var i = 0, st = Math.max(1, Math.floor(pa.count / 3000)); i < pa.count; i += st) {
              var c = new V3(pa.getX(i), pa.getY(i), pa.getZ(i)).applyMatrix4(o.matrixWorld);
              G.worldToLocal(c); mn.min(c); mx.max(c);
            }
          }
          var hsl = colourOf(o), sz = new V3().subVectors(bb.max, bb.min);
          if (hsl && hsl.l < 0.08 && Math.max(sz.x, sz.y, sz.z) < 80) dark.push(G.worldToLocal(new V3().addVectors(bb.min, bb.max).multiplyScalar(0.5).applyMatrix4(o.matrixWorld)));
        });
        local.c = new V3().addVectors(mn, mx).multiplyScalar(0.5);
        local.b = local.c.clone();
        if (dark.length) {
          /* the highest dark part (the shoulder buckle) and the parts right beside it */
          dark.sort(function (a, b) { return b.y - a.y; });
          var top = dark[0], n = 0, acc = new V3(), near = mn.distanceTo(mx) * 0.08;
          dark.forEach(function (d) { if (d.distanceTo(top) < near) { acc.add(d); n++; } });
          local.b = acc.multiplyScalar(1 / n);
        }
        /* the top and bottom of the carrier: its height on screen (the same at every turn) sets the zoom */
        local.top = new V3(local.c.x, mx.y, local.c.z);
        local.bot = new V3(local.c.x, mn.y, local.c.z);
        fitH = 1;
      };
      var place = function (P) {
        if (!G || !fitH) return;
        var key = P.map(function (x) { return x.toFixed(4); }).join(',') + ',' + W + ',' + H;
        if (key === placed) return;
        placed = key;
        var unit = W < 750 ? Math.min(H, W / 1.4) / H : 1;
        g.rotation.y = base.ry + P[0] * Math.PI / 180;
        g.position.x = base.x; g.position.y = base.y;
        cam.zoom = base.zoom;
        cam.updateProjectionMatrix();
        G.updateMatrixWorld(true); cam.updateMatrixWorld(true);
        var t = G.localToWorld(local.top.clone()).project(cam), bt = G.localToWorld(local.bot.clone()).project(cam);
        var h0 = Math.abs(t.y - bt.y) / 2;
        if (!(h0 > 1e-4)) return;
        cam.zoom = base.zoom * Math.max(0.05, P[1] * unit) / h0;
        cam.updateProjectionMatrix();
        var f = local.c.clone().lerp(local.b, P[4]);
        G.localToWorld(f);
        /* how far the focus point moves on screen per world unit (measured, so it holds for Spline's own projection) */
        var n = f.clone().project(cam), nx = f.clone().add(new V3(100, 0, 0)).project(cam), ny = f.clone().add(new V3(0, 100, 0)).project(cam);
        var kx = (nx.x - n.x) / 100, ky = (ny.y - n.y) / 100;
        if (Math.abs(kx) > 1e-9) g.position.x = base.x + ((2 * P[2] - 1) - n.x) / kx;
        if (Math.abs(ky) > 1e-9) g.position.y = base.y + ((1 - 2 * P[3]) - n.y) / ky;
        if ('currentTAAFrame' in app) app.currentTAAFrame = 0;
        if (typeof app.requestRender === 'function') app.requestRender();
      };
      var tintOk = function (name, ms) {
        var hex = tints[name];
        return !!hex && !!window.wlTint && window.wlTint(app, hex, ms);
      };
      var applyColour = function (ms) {
        if (!app) return;
        placed = ''; /* perf (pack 2): the next paint hands Spline its pose again, so the new colour is drawn */
        var ok = tintOk(colour, ms);
        var show = ok || colour === own;
        if (show && root.dataset.madeState !== '3d') posterUntil = Date.now() + 700;
        root.classList.toggle('wl-made--3d', show);
        root.dataset.madeState = show ? '3d' : 'packshot';
      };
      /* WebGL off: the viewer would throw "Error creating WebGL context", so the packshot simply stays */
      var hasGL = function () {
        if (window.wlHasGL) return window.wlHasGL();
        try { var c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (e) { return false; }
      };
      var load = function () {
        if (v || !root.dataset.js || !root.dataset.scene || !glBox) return;
        if (!hasGL()) { root.dataset.madeState = 'poster'; return; }
        root.dataset.madeState = 'loading';
        if (!customElements.get('spline-viewer') && !document.querySelector('script[data-wl-spline]')) {
          var sc = document.createElement('script');
          sc.type = 'module'; sc.src = root.dataset.js; sc.setAttribute('data-wl-spline', '');
          document.head.appendChild(sc);
        }
        v = document.createElement('spline-viewer');
        v.hint = false; /* a Boolean property: the attribute hint="" would switch the drag hint on */
        v.setAttribute('aria-hidden', 'true');
        v.setAttribute('loading-anim-type', 'none');
        v.setAttribute('loading', 'eager'); /* perf (2026-10-22): build now (idle, a screen away), not once it is on screen mid-scroll */
        var sv = v;
        scene(root.dataset.scene).then(function (u) { sv.setAttribute('url', u); });
        v.addEventListener('load-complete', function () {
          try {
            app = v._spline;
            if (!app || !app._scene || !app._camera) { root.dataset.madeState = 'poster'; return; }
            try { if (app.controls) app.controls.enabled = false; } catch (e) {}
            cam = app._camera; G = three(); g = app.findObjectByName(root.dataset.object || 'Group');
            if (!G || !g || !g.rotation || !g.position) { G = null; root.dataset.madeState = 'poster'; return; }
            V3 = G.position.constructor;
            base = { ry: g.rotation.y, x: g.position.x, y: g.position.y, zoom: cam.zoom };
            measure();
            size(); applyColour(0); paint();
            /* perf (2026-10-22): built ahead of time, so usually off screen: rest only after Spline has drawn its first
               frames. Spline starts its render loop a moment after load-complete; a stop() before that leaves the loop
               running while marked as paused, and then it redraws on every frame (seen in testing) */
            setTimeout(function () { glReady = true; if (!active) rest(); }, 1000);
          } catch (e) { G = null; root.classList.remove('wl-made--3d'); root.dataset.madeState = 'poster'; }
        }, { once: true });
        glBox.appendChild(v);
      };

      /* ---- one WebGL model at a time ---- */
      var setActive = function (on) {
        if (on === active) return;
        active = on;
        root.dataset.madeActive = on ? '1' : '0';
        if (on) {
          [].forEach.call(document.querySelectorAll('spline-viewer'), function (o) {
            if (o === v) return;
            /* perf (pack 2): a viewer that runs its own loop (the gallery's 3D panel, wlWake) is held: it stops and
               stays stopped while this scene is on screen, whatever its own checks say */
            if (typeof o.wlWake === 'function') { o.wlHeld = true; stopped.push(o); try { o.wlWake(); } catch (e) {} return; }
            if (!o._spline || typeof o._spline.stop !== 'function' || o._spline.isStopped) return;
            try { o._spline.stop(); stopped.push(o); } catch (e) {}
          });
          if (app && app.isStopped) { wake(); paint(); }
        } else {
          rest();
          /* perf (pack 2): a held viewer is released and starts again only if it can be seen (before, it was
             restarted here wherever it was, and drew off screen, its smoothing frames too) */
          stopped.splice(0).forEach(function (o) {
            try {
              if (typeof o.wlWake === 'function') { o.wlHeld = false; o.wlWake(); }
              else if (o.isConnected && o._spline) o._spline.play();
            } catch (e) {}
          });
        }
      };

      /* ---- the scroll ---- */
      var size = function () { var r = stage.getBoundingClientRect(); W = r.width; H = r.height; };
      var paint = function () {
        raf = 0;
        if (!root.isConnected) return;
        var r = root.getBoundingClientRect(), sr = stage.getBoundingClientRect();
        var span = r.height - sr.height, top = parseFloat(getComputedStyle(stage).top) || 0;
        var p = span > 0 ? (top - r.top) / span : 0;
        p = Math.max(-0.6, Math.min(1, p));
        root.wlP = p;
        var P = poseAt(W < 990 ? KM : KD, p);
        /* the words */
        beats.forEach(function (el) {
          var w = WIN[+el.dataset.madeBeat] || WIN[0];
          var o = Math.min(ss(w[0], w[1], p), 1 - ss(w[2], w[3], p));
          el.style.setProperty('--o', o.toFixed(3));
          el.style.visibility = o < 0.01 ? 'hidden' : '';
        });
        var k = 0; WIN.forEach(function (w, i) { if (p >= w[0] || i === 0) k = i; });
        root.dataset.madeBeat = p > 0.92 ? 4 : k;
        /* the clip card slides in from the right edge and back out */
        if (clip) clip.style.setProperty('--cx', (1 - Math.min(ss(CLIP[0], CLIP[1], p), 1 - ss(CLIP[2], CLIP[3], p))).toFixed(3));
        /* the packshot plays the same moves (the back packshot near the back view); perf (2026-10-22): only while it is
           the one shown (or still fading out), since its size is a layout change on every frame */
        if (root.dataset.madeState !== '3d' || Date.now() < posterUntil) {
          var unit = W < 750 ? Math.min(H, W / 1.4) : H, L = P[1] * unit / PACK_H;
          var u = lerp(0.5, PACK_BUCKLE[0], P[4]), w2 = lerp(0.5, PACK_BUCKLE[1], P[4]);
          poster.style.width = poster.style.height = L.toFixed(1) + 'px';
          poster.style.transform = 'translate3d(' + (P[2] * W - u * L).toFixed(1) + 'px,' + (P[3] * H - w2 * L).toFixed(1) + 'px,0)';
          if (back && front) { var bo = Math.max(0, 1 - Math.abs(((P[0] % 360) + 360) % 360 - 180) / 70); back.style.opacity = bo.toFixed(3); front.style.opacity = (1 - bo).toFixed(3); }
        }
        stage.style.setProperty('--fade', Math.min(1, P[4] * 1.2).toFixed(3));
        pose = P;
        if (G && active) { try { place(P); } catch (e) {} }
      };
      var ask = function () { if (!raf && near) raf = requestAnimationFrame(paint); };
      /* for checks only: the model's framing */
      root.wlMadeInfo = function () { var hidden = []; if (G) G.traverse(function (o) { if (o.isMesh && o.visible === false) hidden.push(o.name); }); return G ? { hidden: hidden, fitH: fitH, zoom: cam.zoom, base: base, c: local.c && local.c.toArray(), b: local.b && local.b.toArray(), pos: [g.position.x, g.position.y], rot: g.rotation.y, W: W, H: H, pose: pose } : null; };
      window.addEventListener('scroll', ask, { passive: true });
      window.addEventListener('resize', function () { size(); ask(); });
      if (window.ResizeObserver) new ResizeObserver(function () { size(); ask(); }).observe(stage);
      size(); paint();

      /* load when about one screen away; active (rendering) while any part is on screen */
      /* (after the page's load event, when the browser is idle, so the product's own panel and photos come first) */
      var later = function (f) {
        var go = function () { if (window.requestIdleCallback) window.requestIdleCallback(f, { timeout: 2500 }); else setTimeout(f, 300); };
        if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      };
      /* perf (2026-10-22): and only at a pause in scrolling (200ms without a scroll), so the build never lands in the
         middle of a flick; if the scene reaches the screen first, it loads then (after the load event), as before */
      var lastScroll = 0;
      window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
      var still = function (f) { var t = Date.now() - lastScroll; if (t >= 200) f(); else setTimeout(function () { still(f); }, 200 - t + 10); };
      new IntersectionObserver(function (es, o) { if (es[es.length - 1].isIntersecting) { o.disconnect(); later(function () { still(load); }); } }, { rootMargin: '100% 0px' }).observe(root);
      new IntersectionObserver(function (es, o) { if (es[es.length - 1].isIntersecting) { o.disconnect(); later(load); } }).observe(root);
      new IntersectionObserver(function (es) { setActive(es[es.length - 1].isIntersecting); if (!raf) raf = requestAnimationFrame(paint); }).observe(root);
      /* perf (2026-10-22): off screen the scene doesn't paint at all; one last paint as it leaves sets its end state */
      new IntersectionObserver(function (es) { near = es[es.length - 1].isIntersecting; if (!raf) raf = requestAnimationFrame(paint); }, { rootMargin: '25% 0px' }).observe(root);

      /* a second guard on the clip's window (wl.js loops it on every frame): if the main thread was too busy and
         playback ran past the window's end, hide the video (the poster shows) until wl.js seeks back in */
      var cv = clip && clip.querySelector('video[data-end]');
      if (cv) cv.addEventListener('timeupdate', function () {
        if (cv.currentTime >= +cv.dataset.end && cv.parentNode) { cv.parentNode.classList.add('wl-hold'); cv.currentTime = +cv.dataset.start || 0; }
      });

      /* the colour: the main picker's radios (Dawn re-renders them, so listen on the document) */
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio' || !t.closest || !t.closest('variant-selects') || !/colou?r/i.test(t.name || '')) return;
        colour = String(t.value || '').trim().toLowerCase();
        root.dataset.color = colour;
        applyColour(450);
        ask();
      });
    }

    function scan(r) { [].forEach.call((r || document).querySelectorAll('[data-made]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-scene"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* the printed page opens every row, then puts them back */
    var was = [];
    window.addEventListener('beforeprint', function () {
      was = [];
      Array.prototype.forEach.call(document.querySelectorAll('.wl-vsc details'), function (d) { was.push([d, d.open]); d.open = true; });
    });
    window.addEventListener('afterprint', function () { was.forEach(function (p) { p[0].open = p[1]; }); was = []; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* the printed page opens every row, then puts them back */
    var was = [];
    window.addEventListener('beforeprint', function () {
      was = [];
      Array.prototype.forEach.call(document.querySelectorAll('.wl-state details'), function (d) { was.push([d, d.open]); d.open = true; });
    });
    window.addEventListener('afterprint', function () { was.forEach(function (p) { p[0].open = p[1]; }); was = []; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-warning-panel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* the printed page opens the panel, then puts it back */
    var was = [];
    window.addEventListener('beforeprint', function () {
      was = [];
      Array.prototype.forEach.call(document.querySelectorAll('.wl-warn-sec__disc'), function (d) { was.push([d, d.open]); d.open = true; });
    });
    window.addEventListener('afterprint', function () { was.forEach(function (p) { p[0].open = p[1]; }); was = []; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-warranty-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* the purchase check: the chosen seller sets whether the order number is required, its hint, and the note */
    function today() {
      var d = new Date(), m = d.getMonth() + 1, day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    }
    function sync(root) {
      var sel = root.querySelector('[data-wlw-seller]');
      if (!sel) return;
      var opt = sel.options[sel.selectedIndex];
      var order = root.querySelector('[data-wlw-order]');
      var opt_word = root.querySelector('[data-wlw-opt]');
      var hint = root.querySelector('[data-wlw-hint]');
      var note = root.querySelector('[data-wlw-note]');
      var sellers = root.querySelector('[data-wlw-sellers]');
      var need = !!opt && opt.getAttribute('data-order') === '1';
      var hint_text = opt ? opt.getAttribute('data-hint') || '' : '';
      var note_text = opt ? opt.getAttribute('data-note') || '' : '';
      if (order) order.required = need;
      if (opt_word) opt_word.hidden = need;
      if (hint) { hint.textContent = hint_text; hint.hidden = !hint_text; }
      if (note && note.textContent !== note_text) note.textContent = note_text;
      if (sellers) sellers.hidden = !(opt && opt.getAttribute('data-else') === '1');
    }
    function setup(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-wlw]'), function (root) {
        var date = root.querySelector('[data-wlw-date]');
        if (date) date.max = today();
        sync(root);
      });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-wlw-seller]')) { var root = t.closest('[data-wlw]'); if (root) sync(root); }
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
    else setup();
    window.addEventListener('pageshow', function (e) { if (e.persisted) setup(); });
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
